import React from "react";

const About = () => {
  return (
    <div className="px-8 lg:px-32 xl:px-52 mt-20">
      <p className="font-bold text-black text-3xl pt-6">About</p>
      <div className="container mx-auto px-2 py-8 text-justify">
        <div className="md:text-[17px] text-black">
          <div className="flex flex-col mx-auto text-black">
            <div>
              <p className="text-sm sm:text-base mb-4 text-justify">
                <b>NutriLens AI: Calorie Counter</b> transforms your
                smartphone into a powerful AI-powered nutrition tracker and
                calorie counter. Simply scan your food, log meals instantly, and
                get detailed nutrition insights to help you achieve your health,
                fitness, and weight management goals.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Whether you're focused on weight loss, muscle gain, calorie
                tracking, macro counting, or healthy eating, NutriLens AI makes
                nutrition tracking simple, fast, and accurate. Snap a photo of
                any meal and get an instant calorie estimate, while our
                AI-powered food scanner automatically identifies foods and their
                nutrition information — no manual searching or complicated meal
                logging required.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Scan barcodes on packaged foods for accurate, real-time calorie
                and macro data, or log meals hands-free with voice food logging.
                Track your daily calories, protein, carbs, fat, and water with
                visual progress rings, and monitor weight, BMI, and body
                measurements over time with detailed charts and historical
                trends.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Your personal AI nutrition coach is always available to answer
                questions about calories, nutrition, and macros, and to provide
                personalized guidance for weight loss, muscle building, and your
                fitness goals. Build healthier habits with smart reminders,
                streak tracking, and achievements as you progress.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Designed for everyday use, NutriLens AI offers fast and accurate
                AI food recognition, privacy-focused nutrition tracking, a clean
                and intuitive experience, and Apple Health integration and
                syncing.
              </p>
            </div>
            <div className="mt-0">
              <p className="text-sm sm:text-base mb-4 text-justify">
                <b>NUTRILENS AI APP FEATURES:</b>
              </p>
              <ul className="list-disc pl-6 text-sm sm:text-base mb-4 text-justify space-y-3">
                <li>
                  <b>AI Food Scanner &amp; Calorie Counter:</b>
                  <p className="text-justify">
                    Snap a photo of any meal and get an instant calorie estimate
                  </p>
                  <p className="text-justify">
                    AI-powered food scanner identifies foods and nutrition
                    information automatically
                  </p>
                  <p className="text-justify">
                    View calories, protein, carbohydrates, fat, and other
                    nutrition details in seconds
                  </p>
                  <p className="text-justify">
                    No manual searching or complicated meal logging required
                  </p>
                </li>
                <li>
                  <b>Barcode Scanner for Packaged Foods:</b>
                  <p className="text-justify">
                    Scan food barcodes instantly for accurate nutrition data
                  </p>
                  <p className="text-justify">
                    Access detailed calorie and macro information in real time
                  </p>
                  <p className="text-justify">
                    Perfect for tracking groceries, snacks, supplements, and
                    packaged meals
                  </p>
                </li>
                <li>
                  <b>Voice Food Logging:</b>
                  <p className="text-justify">Log meals using your voice</p>
                  <p className="text-justify">
                    Simply tell NutriLens AI: Calorie Counter what you ate
                  </p>
                  <p className="text-justify">
                    Save time while maintaining an accurate food diary
                  </p>
                </li>
                <li>
                  <b>Personal AI Nutrition Coach:</b>
                  <p className="text-justify">
                    Ask questions about calories, nutrition, macros, and healthy
                    eating
                  </p>
                  <p className="text-justify">
                    Get guidance for weight loss, muscle building, and fitness
                    goals
                  </p>
                  <p className="text-justify">
                    Receive personalized nutrition insights based on your
                    activity and progress
                  </p>
                </li>
                <li>
                  <b>Track Calories, Macros &amp; Water:</b>
                  <p className="text-justify">
                    Monitor daily calorie intake with visual progress rings
                  </p>
                  <p className="text-justify">
                    Track protein, carbs, and fat throughout the day
                  </p>
                  <p className="text-justify">
                    Record daily water consumption and stay hydrated
                  </p>
                  <p className="text-justify">
                    Set nutrition goals and monitor your progress effortlessly
                  </p>
                </li>
                <li>
                  <b>Body Metrics &amp; Progress Tracking:</b>
                  <p className="text-justify">Track weight changes over time</p>
                  <p className="text-justify">
                    Monitor BMI and body measurements
                  </p>
                  <p className="text-justify">
                    View detailed progress charts and historical trends
                  </p>
                  <p className="text-justify">
                    Stay motivated with measurable results
                  </p>
                </li>
                <li>
                  <b>Meal History &amp; Smart Search:</b>
                  <p className="text-justify">
                    Access your complete food diary anytime
                  </p>
                  <p className="text-justify">Search previous meals quickly</p>
                  <p className="text-justify">
                    Organize nutrition data by day and date
                  </p>
                </li>
                <li>
                  <b>Reach Your Fitness Goals:</b>
                  <p className="text-justify">
                    Set personalized calorie and macro goals
                  </p>
                  <p className="text-justify">
                    Support cutting, maintaining, or bulking phases
                  </p>
                  <p className="text-justify">
                    Build healthier habits with smart reminders and streak
                    tracking
                  </p>
                  <p className="text-justify">
                    Unlock achievements as you progress toward your goals
                  </p>
                </li>
                <li>
                  <b>Advanced Reports &amp; Exports:</b>
                  <p className="text-justify">
                    Weekly nutrition summaries and performance reports
                  </p>
                  <p className="text-justify">
                    Export food and nutrition data as PDF or CSV files
                  </p>
                  <p className="text-justify">
                    Analyze long-term eating habits and health trends
                  </p>
                </li>
                <li>
                  <b>Designed for Everyday Use:</b>
                  <p className="text-justify">
                    Fast and accurate AI food recognition
                  </p>
                  <p className="text-justify">
                    Privacy-focused nutrition tracking
                  </p>
                  <p className="text-justify">
                    Clean and intuitive user experience
                  </p>
                  <p className="text-justify">
                    Apple Health integration and syncing
                  </p>
                </li>
              </ul>
            </div>

            <div className="mt-0">
              <p className="text-sm sm:text-base mb-4 text-justify">
                <b>NUTRILENS AI PREMIUM</b>
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Upgrade to NutriLens AI – Calorie Tracker Premium and unlock:
              </p>
              <ul className="list-disc pl-6 text-sm sm:text-base mb-4 text-justify">
                <li>Unlimited AI food scans</li>
                <li>Advanced nutrition analytics</li>
                <li>Complete meal history access</li>
                <li>Body metrics and progress tracking</li>
                <li>PDF and CSV exports</li>
              </ul>

              <p className="text-sm sm:text-base mb-4 text-justify">
                <b>Premium Plans</b>
              </p>
              <ul className="list-disc pl-6 text-sm sm:text-base mb-4 text-justify">
                <li>Monthly Subscription – Includes a 3-day free trial</li>
                <li>6-Month Subscription – Includes a 7-day free trial</li>
                <li>
                  Yearly Subscription – Includes a 15-day free trial (Best Value)
                </li>
              </ul>

              <p className="text-sm sm:text-base mb-4 text-justify">
                Payment will be charged to your Apple ID account at confirmation
                of purchase. Subscriptions automatically renew unless auto-renew
                is turned off at least 24 hours before the end of the current
                subscription period. Your account will be charged for renewal
                within 24 hours before the current period ends. You can manage or
                cancel your subscription anytime through your App Store account
                settings.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Download <b>NutriLens AI: Calorie Counter</b> today and make
                calorie tracking, nutrition monitoring, food scanning, and
                healthy eating easier than ever.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
